import { hideLoading, showLoading } from './loading.js';
import Modal from './modal.js'
import { resize } from './resizer.js';
import Cropper from 'cropperjs';

let $cropper = null;
let $imgCropper = null;

let modal = null;
let cropper = null;
let cropResolve = null;
let cropReject = null;
let cropSize = null;


function initCropper()
{
	if($cropper)
		return;

	$cropper = document.$('.js-cropper');
	$cropper.$('.js-crop').addEventListener('click', crop)
	$cropper.$('.js-cancel').addEventListener('click', cancel)
	$imgCropper = $cropper.$('.js-cropper-img')
	modal = new Modal($cropper);
}

function crop(e) {
	e.preventDefault();

	showLoading();

	modal.hide();

	cropResolve(cropper.getCroppedCanvas(cropSize));
	
	cropper.destroy();
	
	hideLoading();
}

function cancel(e)
{
	e.preventDefault();

	modal.hide()
	cropper.destroy();

	cropReject('Crop cancelled');
}

export function cropImage(opts, size, file)
{
	let resolve = null
	let reject = null;

	var done = url => {

		let $img = new Image();
		$img.addEventListener('load', e => {

			showCropper(opts, size, $img).then(resolve, reject);
		})

		$img.addEventListener('error', e => {
			reject(new Error('File not a recognised image'))
		})

		$img.src = url;
	};

	if (URL)
	{
		done(URL.createObjectURL(file));
	}
	else if (FileReader)
	{
		let reader = new FileReader();
		reader.onload = e => done(reader.result);
		reader.onerror = e => reject(e)
		reader.readAsDataURL(file);
	}

	return new Promise((y, n) => {
		resolve = y;
		reject = n;
	})
}

export function showCropper(opts, size, $img)
{
	initCropper();

	cropSize = size;

	$imgCropper.src = resize($img, size.width, size.height);
	let maxHeight = window.innerHeight - 230;
	$imgCropper.style.maxHeight = maxHeight + 'px'
	
	modal.show();
	cropper = new Cropper($imgCropper, opts);



	return new Promise((resolve, reject) => {
		cropResolve = resolve;
		cropReject = reject;
	})
}